import alt from '../alt';
import filterAction from './filterAction';
import modalAction from './modalAction';

class contractorAction {
    constructor() {
        this.generateActions(
            'processing',
            'search',
            'searchMode',
            'mcst',
            'staffId',
            'warningMsg',
            'contractorId',
            'updating',
            'contractorSuccess',
            'contractorsSuccess',
            'contractor',
            'isNew',
            'shouldListShow',
            'shouldConListShow',
            'addCondo',
            'addWholeCondo',
            'addService',
            'removeCondo',
            'removeWholeCondo',
            'editService',
            'removeService',
            'clear',
            'listClear',
            'addAddress',
            'editAddress',
            'removeAddress',
            'addContractorSuccess',
            'removeContractorSuccess',
            'updateContractorSuccess',
            'updateWholeCondo',
            'reset',
            'staffReplaced',
            'reminderEmail',
            'condoSuccess',

        );
    }
    getContractor(contractorId) {

        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/contractor/' + contractorId, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        
                        this.contractorSuccess(result);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Message", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
        /*
        this.contractorSuccess(
            {
                _id: "A124",
                contractorName: "E&T Cleaning Services Pte Ltd",
                contracts: [
                    { 
                        condoName: "Casa Jervois", 
                        mcst: "1645", 
                        contract: [
                            {
                                service: "Cleaning", description: "Cleaning", remark: "", 
                                contractStartDate: new Date("2016-11-15"),contractEndDate: new Date("2017-11-14"), 
                                amount: 2400, firstReminder: new Date("2017-11-14"), secondReminder: new Date("2017-11-28")  
                            }, 
                            { 
                                service: "Electric", description: "Electric", remark: "",
                                contractStartDate: new Date("2016-11-15"),contractEndDate: new Date("2017-11-14"), 
                                amount: 2400, firstReminder: new Date("2017-11-14"), secondReminder: new Date("2017-11-28")  
                            }
                        ] 
                    },
                    { 
                        condoName: "Casa Jervois2", 
                        mcst: "1646", 
                        contract: [
                            { 
                                service: "Cleaning", description: "Cleaning", remark: "", 
                                contractStartDate: new Date("2016-11-15"),contractEndDate: new Date("2017-11-14"), 
                                amount: 2400, firstReminder: new Date("2017-11-14"), secondReminder: new Date("2017-11-28") 
                            }
                        ] 
                    },
                ],
                addresses: [
                    { address: "Blk 446 Hougang Ave 8", unitNo: "B1-1635", postal: "530446" }
                ],
                telephone: "",
                fax: "",
                contractorEmail: "crankpwr@singnet.com.sg",
                contactName: "",
                status: 0,
            }
        );
        this.processing(false);
        */
        return true;
    }
    getReminder() {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/reminder', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.reminderEmail(result);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Message", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
        return true;
    }
    updateReminder(reminderEmail) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/reminder', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        modalAction.modalContent({ title: "Successful", content: "Recipient successfully updated" });
                        modalAction.modalClose(true);
                        this.reminderEmail(reminderEmail);
                    } else {
                        let result = JSON.parse(xhttp.responseText);
                        //handle error
                        modalAction.modalContent({ title: "Message", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({
                reminderEmail: reminderEmail
            }));
        }
        return true;
    }
    getCondoList() {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/condo/all', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        let result = JSON.parse(xhttp.responseText);
                        this.condoSuccess(result);
                    } else {
                        //handle error
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }

        
        return true;
    }
    /*
    getAllContractor() {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/contractor/all', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        let result = JSON.parse(xhttp.responseText);
                        this.contractorsSuccess(result);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Message", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }

        return true;
    }
    */
    getContractorByFilter(mcst, staffId) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/contractor?mcst=' + mcst + '&staffId=' + staffId, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.contractorsSuccess(result);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Message", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
        return true;
    }
    getContractorByService(data) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/contractor/service?service=' + data, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.contractorsSuccess(result);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Message", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
        return true;
    }
    getExpireContractor(mcst, staffId) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/contractor/expire?mcst=' + mcst + '&staffId=' + staffId, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        let result = JSON.parse(xhttp.responseText);
                        this.contractorsSuccess(result);
                    } else {
                        //handle error
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }

        return true;
    }

    replaceStaff(oldStaffId, newStaffId, newStaffInfo) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("PUT", '/v1/api/staff/contractor', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.staffReplaced(result);
                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "Employee has been replaced" });
                        modalAction.modalClose(true);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Message", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ oldStaffId: oldStaffId, newStaffId: newStaffId }));
        }

        return true;
    }
    updateContractor(contractor) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("PUT", '/v1/api/contractor/' + contractor._id, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        this.updating(false);

                        this.updateContractorSuccess(contractor);
                        filterAction.updateContractor({ _id: contractor._id, contractorName: contractor.contractorName, contractorEmail: contractor.contractorEmail, telephone: contractor.telephone });
                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "Contractor has been updated" });
                        modalAction.modalClose(true);
                    } else {
                        let result = JSON.parse(xhttp.responseText);
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ contractor: contractor }));
        }

        return true;
    }
    removeContractor(contractorId) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("DELETE", '/v1/api/contractor/' + contractorId, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        let result = JSON.parse(xhttp.responseText);
                        this.removeContractorSuccess(contractorId);
                        filterAction.removeContractorSuccess(contractorId);

                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "Contractor has been removed" });
                        modalAction.modalClose(true);
                    } else {
                        //handle error
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }

        return true;
    }
    addContractor(contractor) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/contractor', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        let result = JSON.parse(xhttp.responseText);
                        this.addContractorSuccess(result);
                        filterAction.addContractorSuccess(result);

                        //show success message
                        modalAction.modalContent({ title: "Successful", content: "Contractor has been added" });
                        modalAction.modalClose(true);
                    } else {
                        //handle error
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ contractor: contractor }));
        }
    }
    getExportContractorList(searchMode, mcst, staffId, service) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/export/contractors', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.responseType = "arraybuffer";
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        var blobUrl = URL.createObjectURL(blob);
                        var link = document.createElement("a"); // Or maybe get it from the current document
                        link.href = blobUrl;
                        link.download = "Contractor_List.xlsx";
                        document.body.appendChild(link); // Or append it whereever you 
                        link.click();
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: "Please contact admin" });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ searchMode: searchMode, mcst: mcst, staffId: staffId, service: service }));
        }
    }
    exportCondoCheckList(){
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/condo/checklist/export', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.responseType = "arraybuffer";
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        var blobUrl = URL.createObjectURL(blob);
                        var link = document.createElement("a"); // Or maybe get it from the current document
                        link.href = blobUrl;
                        link.download = "CondoCheckList.xlsx";
                        document.body.appendChild(link); // Or append it whereever you 
                        link.click();
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: "Please contact admin" });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
    }
    exportContractor(contractorId) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/export/contractor/' + contractorId, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.responseType = "arraybuffer";
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        var blobUrl = URL.createObjectURL(blob);
                        var link = document.createElement("a"); // Or maybe get it from the current document
                        link.href = blobUrl;
                        link.download = "Contractor.xlsx";
                        document.body.appendChild(link); // Or append it whereever you 
                        link.click();
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went wrong", content: "Please contact admin" });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
    }
}
export default alt.createActions(contractorAction);


// WEBPACK FOOTER //
// ./app/actions/contractorAction.js